import { forwardRef, createElement } from 'react';
import '../Icon/components/index.js';
import '../Icon/Icon.js';
import '../Accordion/Accordion.js';
import '../Backdrop/Backdrop.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Badge/Badge.js';
import '../Tooltip/Tooltip.js';
import { IconButton } from '../IconButton/IconButton.js';
import '../Banner/Banner.js';
import '../Button/Button.js';
import '../Spinner/Spinner.js';
import '../Toast/Toaster.js';
import { useLocalization } from '../Provider/Provider.js';
import '../Calendar/Calendar.js';
import '../Card/Card.js';
import '../Checkbox/Checkbox.js';
import '../../utils/hooks/useProxiedRef.js';
import { Input } from '../Input/Input.js';
import '../../utils/hooks/useListKeyboardNavigation.js';
import '../../utils/hooks/useListScrollTo.js';
import '../../utils/hooks/useBoundingClientRectListener.js';
import '../Combobox/Combobox.js';
import '../../utils/date.js';
import '../../utils/mergeRefs.js';
import '../Popover/Popover.js';
import '../Datepicker/Datepicker.js';
import '../Dialog/Dialog.js';
import '../Field/Field.js';
import '../Form/Form.js';
import '../Group/Group.js';
import '../Hanger/Hanger.js';
import '../HoverCard/HoverCard.js';
import '../Listbox/Listbox.js';
import '../RadioGroup/RadioGroup.js';
import '../Menu/Menu.js';
import '../Treeview/Treeview.js';
import '../../utils/hooks/useDropTarget.js';
import '../Navigation/Navigation.js';
import '../Select/Select.js';
import '../Pagination/usePagination.js';
import '../Pagination/Pagination.js';
import '../Progress/Progress.js';
import '../Table/components/Table.js';
import '../Table/components/PaginatedTable.js';
import '../Table/components/WindowedTable.js';
import '../Table/util/rowIndexPath.js';
import '../Table/hooks/useRowCreation.js';
import '../Tabs/Tabs.js';
import '../Textarea/Textarea.js';
import '../Switch/Switch.js';
import '../Tour/Tour.js';
import '../../utils/hooks/useOnClickOutside.js';

const SearchInput = /*#__PURE__*/forwardRef(function SearchInput({
  onSearch,
  ...props
}, ref) {
  const {
    texts
  } = useLocalization();

  const handleClick = () => {
    if (!props.disabled) {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch(props.value);
    }
  };

  const handleKeyDown = event => {
    var _props$onKeyDown;

    const isEnterKeyPressed = event.key === 'Enter';

    if (isEnterKeyPressed) {
      handleClick();
    }

    (_props$onKeyDown = props.onKeyDown) === null || _props$onKeyDown === void 0 ? void 0 : _props$onKeyDown.call(props, event);
  };

  return createElement(Input, Object.assign({
    "aria-label": texts.searchInput.inputLabel
  }, props, {
    button: createElement(IconButton, {
      icon: "search",
      className: "!border-transparent !bg-transparent focus:!border-transparent peer-focus:!border-transparent peer-focus:peer-active:!border-transparent",
      disabled: props.disabled,
      onClick: handleClick
    }),
    onKeyDown: handleKeyDown,
    ref: ref,
    type: "search"
  }));
});

export { SearchInput };
//# sourceMappingURL=SearchInput.js.map
